import { render, staticRenderFns } from "./ViewFundraiserDetails.vue?vue&type=template&id=067288a9&scoped=true&"
import script from "./ViewFundraiserDetails.vue?vue&type=script&lang=js&"
export * from "./ViewFundraiserDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewFundraiserDetails.vue?vue&type=style&index=0&id=067288a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067288a9",
  null
  
)

export default component.exports